// Descargas y aperturas de archivos servidos por el backend cuando el
// endpoint requiere AUTH-TOKEN. Los <a href> no permiten inyectar
// headers custom, así que cualquier export protegido (XLSX, CSV, PDF)
// debe pasar por este helper para no romper con 401.

const TOKEN_STORAGE_KEY = 'token';
const REVOKE_AFTER_MS = 60_000;

async function fetchAuthorizedBlob(url, onError) {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (!token) {
    onError?.({ type: 'no_token' });
    return null;
  }
  let response;
  try {
    response = await fetch(url, { headers: { 'AUTH-TOKEN': token } });
  } catch (e) {
    onError?.({ type: 'network', error: e });
    return null;
  }
  if (!response.ok) {
    onError?.({ type: 'http_error', status: response.status });
    return null;
  }
  return response.blob();
}

function scheduleRevoke(blobUrl) {
  setTimeout(() => window.URL.revokeObjectURL(blobUrl), REVOKE_AFTER_MS);
}

// Descarga forzada de un archivo (XLSX, CSV) con un nombre específico.
// onError: ({ type: 'no_token' | 'network' | 'http_error', status?, error? }) => void
export async function downloadAuthorizedFile({ url, filename, onError }) {
  const blob = await fetchAuthorizedBlob(url, onError);
  if (!blob) return;
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  scheduleRevoke(blobUrl);
}

// Abre un archivo (típicamente PDF) en una nueva pestaña. Útil cuando
// querés que el browser renderice inline en lugar de forzar descarga.
export async function openAuthorizedFile({ url, onError }) {
  const blob = await fetchAuthorizedBlob(url, onError);
  if (!blob) return;
  const blobUrl = window.URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
  scheduleRevoke(blobUrl);
}
